/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface ActivateChannelCachingMutationProps {
    cache: boolean;
    channel: Channel;
}

export default class ActivateChannelCachingMutation extends Relay.Mutation<ActivateChannelCachingMutationProps> {
    static propTypes = {
        cache: PropTypes.bool.isRequired,
        channel: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {activateChannelCaching}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on ActivateChannelCachingPayload {
                channel {
                    id,
                    realId,
                    cachingStatus,
                    cachingInProgressJob {
                        id,
                        progress,
                        status
                    },
                    metadata,
                    organisation {
                        companySearchAddon {
                            id,
                            channelCachingPlugins {
                                id,
                                realId,
                                organisation_id,
                            },
                            channelAllPlugins {
                                id,
                                realId,
                                organisation_id,
                            },
                            channelCachingPlugins {
                                id,
                                realId,
                                organisation_id,
                            },
                        }

                    }
                },
                job {
                    id,
                    organisation_id,
                    realId,
                    name
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        },
        {
            type: 'FIELDS_CHANGE',
            fieldIDs: {
                'channel': this.props.channel.id
            }
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
            cache: this.props.cache
        };
    }
}
